import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["cssFn"];
/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import { N500 } from '@atlaskit/theme/colors';
import { gridSize } from '@atlaskit/theme/constants';
var defaultStyle = {
  alignItems: 'center',
  boxSizing: 'border-box',
  color: "var(--ds-text-subtle, ".concat(N500, ")"),
  display: 'flex',
  flexShrink: 0,
  flexDirection: 'column',
  height: '100vh',
  paddingBottom: 2 * gridSize(),
  paddingTop: 3 * gridSize(),
  width: 8 * gridSize()
};
var sidebarCSS = function sidebarCSS() {
  return defaultStyle;
};
var Sidebar = function Sidebar(_ref) {
  var cssFn = _ref.cssFn,
    props = _objectWithoutProperties(_ref, _excluded);
  // eslint-disable-next-line @repo/internal/react/consistent-css-prop-usage, @repo/internal/react/no-unsafe-spread-props, @repo/internal/react/use-primitives
  return jsx("div", _extends({
    css: css(cssFn(defaultStyle))
  }, props));
};
export default {
  component: Sidebar,
  cssFn: sidebarCSS
};